import React, { Component } from "react"
import {Link, graphql} from 'gatsby'
import { scroller } from "react-scroll";
import { Helmet } from "react-helmet";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Layout from "../../components/layout";
import Header from "../../components/header";
import check from '../../images/check-icon.svg'
import Popup from "reactjs-popup";
import Modal from 'react-awesome-modal';
import ReactReadMoreReadLess from "react-read-more-read-less";
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import ScrollAnimation from 'react-animate-on-scroll';
import {Animated} from "react-animated-css";
import "../../css/style.css";
import "../../css/animate.min.css";
import "../../css/responsive.css";
import "../../css/bootstrap.min.css";
import "../../css/swiper-bundle.min.css";
import InstituteTabs from "../../components/institutiontabs";
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Mousewheel, Parallax } from 'swiper';
import PopupForm from "../../components/popupForm";
import ReactGA from 'react-ga'
import InstitutionsBannerSection from "./InstitutionsBannerSection";
import cardImg from '../../images/programs/degree.svg'
import cardImg1 from '../../images/programs/start online.svg'
import cardImg2 from '../../images/programs/get your visa.svg'
import cardImg3 from '../../images/programs/completed overseas.svg'
import UniversityCardView from '../../components/UniversityCardView'

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, Thumbs, Mousewheel, Parallax]);

const AutoplaySlider = withAutoplay(AwesomeSlider);

class University  extends Component {
    componentDidMount(){
    var swiper = new Swiper('.universities-swiper',  {
        slidesPerView: 3,
    slidesPerColumn: 2,
    spaceBetween: 30,
    observer: true,
    observeParents: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 1,
            slidesPerColumn: 1,
            spaceBetween: 0,
            observer: true,
            observeParents: true,
        },
        // when window width is >= 480px
        480: {
            slidesPerView: 2,
            slidesPerColumn: 2,
            spaceBetween: 20,
            observer: true,
            observeParents: true,
        },
        // when window width is >= 640px
        768: {
            slidesPerView: 3,
            slidesPerColumn: 2,
            spaceBetween: 30,
            observer: true,
            observeParents: true,
        }
    }
});
    var swiper = new Swiper('.professors-swiper',  {
        
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            // bulletActiveClass: 'twinhealth-bullet'
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });
}


  constructor(props) {
        super(props);
        this.state = {
            time: 90000000
        }
    }
    scrollToSection = () => {
        scroller.scrollTo("universitie-partner-sec", {
          duration: 800,
          delay: 0,
          smooth: "easeInOutQuart",
        });
    };
 
    handlePopupWindow = () => {
        this.setState({ time: Math.random() })
    }
 

  render(){

    const uniArr = this.props.data.allWordpressWpUniversities.nodes

    const cardData = [
        {
            image: cardImg, title: "Choose Your University", text: "Get admission into a business degree into the top-ranked Murdoch university in Dubai"
        },
        {
            image: cardImg1, title: "Start Online", text: "Complete the first half of Year 1 online in just 3.5 months (2 modules in 7 weeks)  without any delays thanks to multiple intakes (intake every 2 months)"
        },
        {
            image: cardImg2, title: "Get Your Visa", text: "Complete your visa process while studying and be ready to go overseas by the end of the program"
        },
        {
            image: cardImg3, title: "Complete Overseas", text: "Progress to the overseas campus to complete the remainder of your degree and apply for post study work rights"
        }
    ]
   
    return(
        
        <div>
          <PopupForm time={this.state.time} />
          <Layout>
            <Helmet>
                <title>
                    Top Universities in Dubai | The WorldGrad
                </title>
                <meta
                name="description"
                content="Know about the most affordable and best universities in Dubai, courses, tuitions fees, visa requirements and all the other details you need to know to pursue your dream of studying abroad via The WorldGrad."
                />
                <meta
                name="keywords"
                content="study in australia cost for indian students, study in australia cost, what is study in australia cost for indian students,"
                />
            </Helmet>
            <div class="universitie-banner-sec">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="universitie-banner-inner">
                                <ul class="whitebackground breadcrumb">
                                    <li class="breadcrumb-item"><a href="/">The WorldGrad </a></li> 
                                    <li class="breadcrumb-item active">Institutions</li> 
                                </ul>
                                
                                <InstitutionsBannerSection 
                                    country="Dubai's" 
                                    bannerUrl="https://media.publit.io/file/TheWorldgrad/3Institutions/Dubai/institutions-dubai.jpg"
                                    altDescription="Burj-al-Arab"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* second section */}
            <div class="universitie-partner-sec">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="title">
                                <h2>Our Partner Institutions</h2>
                            </div>
                            <Tabs>
                                <TabPanel>
                                    <section id="rauchbier" class="tab-panel">
                                        <div class="interest-explore-inner">
                                            <div class="swiper-container universities-swiper">
                                                <div class="swiper-wrapper row justify-content-center m-0">
                                                    {
                                                        uniArr.map(university => {
                                                            return (
                                                                <div className="col-md-4" key={university.id}>
                                                                    <Link to={`/university-detail/${university.slug}`}>
                                                                        <div class="swiper-slide" value="Open" onClick={() => {
                                                                            // this.openModal5()
                                                                            ReactGA.event({
                                                                                category: "Institutions",
                                                                                action: "Clicks",
                                                                                label: `UAE - ${university.title}`
                                                                            })
                                                                        }}>
                                                                            <InstituteTabs
                                                                                ImageUrl={university.acf.university_thumbnail.source_url}
                                                                                // ImageUrl="https://media.publit.io/file/TheWorldgrad/3Institutions/Austrila/LaTrobe3_web-1333x1000_eoqnf5.jpg"
                                                                                UniversityName={university.title}
                                                                            />
                                                                        </div>
                                                                    </Link>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                            {/* <a 
                                                class="btn-default wow fadeInUp" 
                                                data-wow-duration="1s" 
                                                data-wow-delay=".1s" 
                                                onClick={() => this.openModal()}
                                            >
                                                Speak With Us
                                            </a> */}
                                        </div>    
                                    </section>
                                </TabPanel>
                            </Tabs>
                         </div>   
                    </div>     
                </div>   
            </div>
        </Layout>
    </div>        
    )
  }
}

export default University;

export const WorldGradUniversities = graphql`
    {
        allWordpressWpUniversities(filter: {acf: {country: {eq: "UAE"}}}) {
        nodes {
            id
            slug
            title
            acf {
                university_thumbnail {
                    source_url
                }
            }
        }
        }
    }
`
